import { Button } from 'components/common/button/Button'
import useHardNavigate from 'hooks/useHardNavigate'
import { AnalyticsActionType } from 'types/common/analytics.type'
import { EVENTS, trackAnalytics } from 'utils/analytics'
interface ReturnToLandingButtonProps {
  variant?: 'navigationControl' | 'navigationControlHoverWhite'
}
export const ReturnToLandingButton = ({ variant = 'navigationControl' }: ReturnToLandingButtonProps) => {
  const hardNavigate = useHardNavigate()

  return (
    <Button
      variant={variant}
      text="See Experience Loop Process"
      border
      onClick={() => {
        hardNavigate('/')
        trackAnalytics({
          type: AnalyticsActionType.action,
          payload: EVENTS.ACTION.BACK_TO_LANDING_BOTTOM,
        })
      }}
    />
  )
}
